import { Button, TextInput } from 'components/core';
import React, { FC, useState } from 'react';
import { Styled, ProjectNameProps } from './';
import { useI18n } from 'contexts/i18n';

const ProjectName: FC<ProjectNameProps> = ({
  onSaveProjectName,
  isLoading,
}) => {
  const [projectName, setProjectName] = useState('');

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && projectName.length > 0) {
      onSaveProjectName(projectName);
    }
  };

  const i18n = useI18n();

  return (
    <Styled.ProjectNameContainer>
      <Styled.ProjectNameWrapper>
        <Styled.Title>{i18n['Name your file']}</Styled.Title>
        <Styled.Description>
          {i18n['To finish customizing later, you can access your drafts by going to Profile']} &gt; {i18n['Drafts']}
        </Styled.Description>
        <Styled.InputWrapper>
          <TextInput
            value={projectName}
            width="100%"
            onChange={e => {
              setProjectName(e.target.value);
            }}
            onKeyDown={handleKeyDown}
            size="sm"
            placeholder={i18n['Name']}
          />
        </Styled.InputWrapper>
        <Styled.ButtonWrapper>
          <Button
            onClick={() => onSaveProjectName(projectName)}
            loading={isLoading}
            disabled={projectName.length === 0}
          >
            {i18n['Okay']}
          </Button>
        </Styled.ButtonWrapper>
      </Styled.ProjectNameWrapper>
    </Styled.ProjectNameContainer>
  );
};

export default ProjectName;
